const shortsPathPrefix = '/shorts/';
const embedPathPrefix = '/embed/';
const directPathPrefix = '/v/';

const prefixes = [shortsPathPrefix, embedPathPrefix, directPathPrefix];

export interface YoutubeVideoInfo {
  videoId: string;
  isShorts: boolean;
}

const tryParseUrl = (raw: string): URL | null => {
  try {
    return new URL(raw);
  } catch (err) {
    return null;
  }
};

export const parseYoutubeUrl = (rawUrl: string): YoutubeVideoInfo | null => {
  if (!rawUrl) {
    return null;
  }
  const url = tryParseUrl(rawUrl);

  if (!url) {
    return null;
  }

  if (url.host === 'youtu.be') {
    const videoId = url.pathname.slice(1);
    return { videoId, isShorts: false };
  }

  if (url.host === 'studio.youtube.com') {
    const videoId = url.pathname.split('/')[2] ?? null;
    return videoId ? { videoId, isShorts: false } : null;
  }

  if (
    url.host === 'www.youtube.com' ||
    url.host === 'youtube.com' ||
    url.host === 'music.youtube.com'
  ) {
    if (url.pathname.startsWith(shortsPathPrefix)) {
      const videoId = url.pathname.slice(shortsPathPrefix.length);
      return { videoId, isShorts: true };
    }

    const knownPrefix = prefixes.find(
      prefix => url.pathname.startsWith(prefix) && prefix !== shortsPathPrefix,
    );

    if (knownPrefix) {
      const videoId = url.pathname.slice(knownPrefix.length);
      return { videoId, isShorts: false };
    }

    if (url.pathname.startsWith('/watch')) {
      const videoId = url.searchParams.get('v');
      return videoId ? { videoId, isShorts: false } : null;
    }
  }

  return null;
};
